<!--
 * @Author: Dee
 * @Date: 2021-06-19 12:48:37
 * @LastEditTime: 2022-04-21 18:28:27
 * @LastEditors: soul(佘家骏) 
 * @Description: In User Settings Edit
 * @FilePath: \yq-act-web\src\views\hlb-purchase-act\light.vue
-->
<template>
  <div class="bg">
    <BaseImg :option="{
      style: {
        margin: '12px 0 0 16px',
        alignSelf: 'flex-start',
        width: '89px',
      },
      url: 'logo.png',
    }"/>
    <div class="mh-wrap">
      <div class="count">
        <div class="line"></div>
        <div>剩余抽奖次数：<span>{{gameCount}}</span></div>
      </div>
      <div class="mh-box">
        <div v-for="index in 3" :key="index">
          <img :src="`${imgHost}draw_box1.png?v=${$config.OSSVersion}`" />
        </div>
      </div>
    </div>
    <div class="draw-btn" @click="goDraw()">点击抽奖</div>
    <!-- <div class="prize-box" :class="{box1: selectIndex === 1, box3: selectIndex === 3}">
      <div class="nav-list">
        <div class="nav" :class="{active: selectIndex === 1}" @click="changeNav(1)">赏金盲盒</div>
        <div class="nav" :class="{active: selectIndex === 2}" @click="changeNav(2)">高奢盲盒</div>
        <div class="nav" :class="{active: selectIndex === 3}" @click="changeNav(3)">美居盲盒</div>
      </div>
      <div class="prize">
        <template v-if="selectIndex === 1">
          <div class="tips">至多200元随机“金喜”</div>
          <img
            :src="imgHost + 'prize1.png?v=?v=' + $config.OSSVersion"
          />
        </template>
        <template v-else-if="selectIndex === 2">
          <div class="tips">iPhone13、海蓝之谜精华面霜、戴森吹风机<br />科沃斯扫拖一体机器人、DJI大疆灵眸Action2</div>
          <img
            :src="imgHost + 'prize2.png?v=?v=' + $config.OSSVersion"
          />
        </template>
        <template v-else-if="selectIndex === 3">
          <div class="tips">ARMANI红管唇釉405、小米米家智能电饭煲、
            <br />摩飞多功能料理锅、九阳便携榨汁机
            <br />天猫超市购物卡（500元、200元、100元、50元）
            <br />星巴克星礼卡（500元、200元、100元）
          </div>
          <img
            :src="imgHost + 'prize3.png?v=?v=' + $config.OSSVersion"
          />
        </template>
      </div>
    </div> -->
    <!-- <div class="btn-layer">
      <div @click="goShare" class="act_animate_shake_seesaw_config"></div>
    </div> -->
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
// import Vue from "vue/dist/vue.js";
export default {
  name: "",
  components: {},
  data() {
    return {
      click: true,
      selectIndex: 2,
      gameCount: 0,  //剩余抽卡次数
      prizeId: 0,
      myprizeList: [], //奖品列表
      boxName: '普通',
      autoChangeStatus: true,
      clickChangeStatus: true
    };
  },
  computed: {
    boxNum() {
      let num = 1
      if (this.boxName.indexOf('普通') > -1) {
        num = 1
      } else if (this.boxName.indexOf('高奢') > -1) {
        num = 2
      } else if (this.boxName.indexOf('美居') > -1) {
        num = 3
      }
      return num
    }
  },
  watch: {
  },
  methods: {
    // 剩余抽奖次数
    async getCount() {
      const data = await this.$httpdf.get(this.apiHost + 'user/gameCount')
      if (data.code == 0) {
        this.gameCount = data.data.gameCount
      }
    },
    //立即抽奖
    async goDraw() {
      if(!this.click){
        return;
      }
      if (this.gameCount >= 1) {
        this.click = false;
        this.gameCount--
        //获取奖品
        const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/lottery')
        if (data.code == 0) {
          this.prizeId = data.data;
        }
        if (this.prizeId != 0) {
          this.$modal.drawForm.alert({
            isBox: true,
            prizeId: this.prizeId,
            boxNum: this.boxNum,
            // boxName: this.boxName.substr(0, 2)
          }).then((res)=> {
            if (res == 'box') {
              this.$modal.drawForm.alert({ prizeId: this.prizeId })
            }
            this.prizeId = 0
          })
        } else {
          this.$modal.drawForm.alert({
            drawTxt: 3,
            thanksTxt: `很遗憾，本次未能抽中奖品，继续参与游戏即可获得抽盲盒机会！`,
            btnTxt: '呼朋唤友',
            btnStatus: 1
          })
        }
        this.click = true;
      } else {
        this.$modal.drawForm.alert({
          drawTxt: 2,
          thanksTxt: `抽奖机会用完了，推荐好友<br />参与活动还能获得更多「金喜」`,
          btnTxt: '呼朋唤友',
          btnStatus: 1
        })
      }
    },
    async getPrize () {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/view')
      if (data.code == 0) {
        this.myprizeList = data.data
      } else {
        MessageBox.alert(data.msg)
      }
    },
    changeNav(num) {
      this.selectIndex = num
    },
  },
  async created() {
    await this.getCount();
    await this.getPrize();
    // this.$modal.drawForm.alert({
    //   isBox: true,
    //   prizeId: 113498,
    //   boxNum: this.boxNum,
    // })
    // this.$modal.drawForm.alert({prizeId: 113413});
    // this.$modal.drawForm.alert({prizeId: 113498});
    // setTimeout(this.autoChangeNav, 2000)
  },
  mounted() {
    this.$wx.shareCallBackFunList.push("share1", async() => {
      await this.$httpdf.post(this.apiHost + 'share/share');
      this.$config.openYqAnalytics && this.$biz.handlerYqAnalyticsEvent('share')
      this.$modal.share.close()
      this.$config.openSalesLeads && this.$rsh5.actShare()
      this.getCount()
    });
  },
};
</script>

<style lang='scss' scoped>
.bg {
  padding-bottom: 90px;
  background: url( $imgHost + 'index_top.png?v=' + $OSSVersion) 0 0 / 100% no-repeat, linear-gradient(0deg, #FAE5C7 0%, #F6C574 100%);
  .count {
    position: relative;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #E76130;
    line-height: 19px;
    display: flex;
    justify-content: center;
    > div {
      position: relative;
    }
    span {
      font-size: 18px;
      font-weight: bold;
    }
    .line {
      position: absolute;
      bottom: -2px;
      width: 120%;
      height: 6px;
      background: #F9DA9C;
      border-radius: 3px;
    }
  }
  .mh-wrap  {
    margin-top: 245px;
    width: 343px;
    height: 378px;
    padding: 102px 0 0;
    background: url( $imgHost + 'mh_box.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    @extend .flex-center-center;
    flex-flow: column nowrap;
    justify-content: flex-start;
  }
  .mh-box {
    margin-top: 85px;
    width: 309px;
    height: 106px;
    background: url( $imgHost + 'mh_table.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    position: relative;
    >div {
      position: absolute;
      img {
        width: 84px;
      }
      &:nth-child(1) {
        top: -37px;
        left: 26px;
        animation: upDownAni 1.3s linear infinite;
      }
      &:nth-child(2) {
        top: -25px;
        left: 108px;
        animation: upDownAni 1.3s 0.5s linear infinite;
      }
      &:nth-child(3) {
        top: -37px;
        right: 26px;
        animation: upDownAni 1.3s 1s linear infinite;
      }
    }
  }
  .draw-btn {
    margin-top: 18px;
    width: 160px;
    height: 44px;
    background: linear-gradient(0deg, #EE9038 0%, #EA5E2B 100%);
    box-shadow: 0px 3px 8px 0px rgba(225, 61, 36, 0.51);
    border-radius: 22px;
    position: relative;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 19px;
    letter-spacing: 3px;
    text-indent: 3px;
    @extend .flex-center-center;
    &::after {
      display: block;
      content: '';
      width: 49px;
      height: 34px;
      background: url('https://assets.rurushishi.com/activies/common/icon_head.png?v=' + $OSSVersion) center / 100% no-repeat;
      position: absolute;
      bottom: -10px;
      right: -20px;
      animation: twinkle 1s infinite linear;
    }
  }
  .prize-box {
    margin-top: 23px;
    width: 351px;
    height: 295px;
    background: url( $imgHost + 'draw_box.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    padding: 14px 20px 0;
    box-sizing: border-box;
    &.box1 {
      background: url( $imgHost + 'prize_box2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      .prize {
        img {
          margin-top: -6px;
          width: 267px;
        }
      }
    }
    &.box3 {
      background: url( $imgHost + 'prize_box1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      .prize {
        img {
          width: 223px;
          margin-top: 17px;
        }
      }
    }
    .nav-list {
      display: flex;
      .nav {
        flex: 1;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-style: italic;
        color: #FF8B50;
        text-align: center;
        line-height: 26px;
        &.active {
          font-size: 0;
          flex: none;
          height: 26px;
        }
        &:nth-child(1) {
          &.active {
            width: 157px;
            margin-right: -20px;
            background:url( $imgHost + 'nav1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
            transform: translateX(0.5px);
          }
        }
        &:nth-child(2) {
          &.active {
            width: 162px;
            margin: 0 -20px;
            background:url( $imgHost + 'nav2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
          }
        }
        &:nth-child(3) {
          &.active {
            width: 156px;
            margin-left: -20px;
            margin-right: 3px;
            background:url( $imgHost + 'nav3.png?v=' + $OSSVersion) 0 0 / 100% 100% no-repeat;
            transform: translateX(0);
          }
        }
      }
    }
    .prize {
      padding-top: 18px;
      text-align: center;
      position: relative;
      .tips {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 18px;
      }
      img {
        width: 196px;
        margin-top: 25px;
      }
    }
  }
}
.btn-layer {
  position: fixed;
  bottom: 40px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  z-index: 99;
  >div {
    width: 213px;
    height: 43px;
    background: url( $imgHost + 'draw_btn1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
  }
}
</style>
